<div class="PageContent">

    <div class="overlay" *ngIf="AddNewHSCode || ShowHSCodesMenu || ShowAddNewProductForm || ShowDeleteProductQuestion;"></div>
    <div class="overlayTransparent animated fadeIn" *ngIf="this.SearchedProducts?.length > 0" (click)="CloseOverlay();"></div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProductQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteProductQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;DeleteIndustryProduct();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowResetIndustryProductsSearchResultsQuestion">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowResetIndustryProductsSearchResultsQuestion = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ResetIndustryProductsSearchResults' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'ResetIndustryProductsSearchResultsDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowResetIndustryProductsSearchResultsQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ResetIndustryProductsSearchResults();">{{ 'ResetSearchResults' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="DupplicateError && DupplicateErrorAdd">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="DupplicateError = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ProductDupplicateErrorTitle' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{this.DupplicateErrorMessage}}
      </div>
    
      <div class="InfoQuestionCommands">
        <button style="color: #f60;" [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="DupplicateError = false;DupplicateErrorAdd = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DupplicateError = false;DupplicateErrorAdd = false;AddIndustryProudct(true);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="DupplicateError && DupplicateErrorUpdate">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="DupplicateError = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'ProductDupplicateErrorTitle' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{this.DupplicateErrorMessage}}
      </div>
    
      <div class="InfoQuestionCommands">
        <button style="color: #f60;" [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="DupplicateError = false;DupplicateErrorUpdate = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="DupplicateError = false;DupplicateErrorUpdate = false;UpdateIndustryProduct(true);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="NewProductContainer animated fadeInDown" *ngIf="ShowAddNewProductForm == true;">
      <div class="NewProductContainerTitleBar">
        <p *ngIf="this.NewProduct.ID == 0;">{{'AddNewProduct' | translate}}</p>
        <p *ngIf="this.NewProduct.ID > 0;">{{'ModifyProduct' | translate}}: {{this.NewProduct.Brand.Name}} {{this.NewProduct.Name}}</p>
        <i class="material-icons" (click)="ShowAddNewProductForm = false;">close</i>
      </div>
      <div class="NewProductContainerBody">
        <div class="TwoThirdsColumn">

          <div class="ColumnTitle">
            <i class="material-icons">radio_button_checked</i>
            {{'GeneralInformation' | translate}}
          </div>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Name' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.NewProduct.Name">
          </mat-form-field>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'PartNumber' | translate }}</mat-label>
            <input matInput placeholder="{{ 'PartNumber' | translate }}" autocomplete="off" [(ngModel)]="this.NewProduct.PartNumber">
          </mat-form-field>

          <mat-form-field class="BrandSelectContainer" appearance="outline">
            <mat-label>{{'SelectBrand' | translate}}*</mat-label>
            <input class="BrandSelect"
                   type="text"
                   placeholder="{{'SelectBrand' | translate}}"
                   matInput
                   [matAutocomplete]="auto1"
                   [(ngModel)]="this.NewProduct.Brand.Name"
                   (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                   (click)="InitializeBrands();">
            <i class="material-icons BrandSelectCloseIcon" *ngIf="this.NewProduct.Brand?.Name?.length > 0;" (click)="ClearSearchBrand();">close</i>
            <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.NewProduct.Brand?.Name?.length > 0) != true;">search</i>
            <mat-autocomplete #auto1="matAutocomplete">
              <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.NewProduct.Brand = brand;">
                {{brand.Name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox" *ngIf="this.NewProduct.ID == 0;">
            <mat-label>{{ 'Creator' | translate }}*</mat-label>
            <input disabled="true" matInput placeholder="{{ 'Creator' | translate }}*" autocomplete="off" [(ngModel)]="this.NewProduct.Creator.UIName">
          </mat-form-field>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'UpdateingUser' | translate }}*</mat-label>
            <input disabled="true" matInput placeholder="{{ 'UpdateingUser' | translate }}*" autocomplete="off" [(ngModel)]="this.NewProduct.Updater.UIName">
          </mat-form-field>

          <mat-form-field appearance="outline"class="ProductPropertyTextBox">
            <mat-label>{{ 'ProductManufacturingStatus' | translate }}</mat-label>
            <mat-select name="ProductManufacturingStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="this.NewProduct.ManufacturingStatus">
              <mat-option *ngFor="let s of this.ProductManufacturingStatuses" [value]="s">
                {{s.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline"class="ProductPropertyTextBox">
            <mat-label>{{ 'ProductVersionStatus' | translate }}</mat-label>
            <mat-select name="ProductVersionStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="this.NewProduct.VersionStatus">
              <mat-option *ngFor="let s of this.ProductVersionStatuses" [value]="s">
                {{s.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div class="OneThirdColumn">

          <div class="ColumnTitle">
            <i class="material-icons">format_list_bulleted</i>
            {{'Details' | translate}}
          </div>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Weight' | translate }}</mat-label>
            <input (keypress)="parent.OnlyNumbers($event)" matInput placeholder="{{ 'Weight' | translate }}" autocomplete="off" [(ngModel)]="this.NewProduct.Stats.Weight">
          </mat-form-field>

          <mat-form-field appearance="outline"class="ProductPropertyTextBox">
            <mat-label>{{ 'WeightMeasurementType' | translate }}</mat-label>
            <mat-select name="WeightMeasurementType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.NewProduct.Stats.WeightMeasurementType">
              <mat-option *ngFor="let w of this.WeightMeasurementTypes" [value]="w">
                {{w.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'HSCode' | translate }}</mat-label>
            <input matInput placeholder="{{ 'HSCode' | translate }}" autocomplete="off" [(ngModel)]="this.NewProduct.Stats.HSCode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'EAN' | translate }}</mat-label>
            <input matInput placeholder="{{ 'EAN' | translate }}" autocomplete="off" [(ngModel)]="this.NewProduct.Stats.EAN">
          </mat-form-field>

          <mat-form-field appearance="outline"class="ProductPropertyTextBox">
            <mat-label>{{ 'COO' | translate }}</mat-label>
            <mat-select name="COO" [compareWith]="this.parent.compareFn" [(ngModel)]="this.NewProduct.Stats.COO">
              <mat-option *ngFor="let c of this.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="ProductPropertyTextBox">
            <mat-slide-toggle [(ngModel)]="this.NewProduct.Activated">{{'ActiveProduct' | translate}}</mat-slide-toggle>
          </div>

        </div>
      </div>
      <div class="NewProductContainerCommands">
        <button mat-raised-button color="primary" class="AddNewProductButton" (click)="AddIndustryProudct();" *ngIf="this.NewProduct.ID == 0;">
          <i class="material-icons">add</i>
          {{'AddNewProduct' | translate}}
        </button>

        <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.NewProduct.ID > 0;" (click)="UpdateIndustryProduct();">
          <i class="material-icons">edit</i>
          {{'ModifyProduct' | translate}}
        </button>
      </div>
    </div>

    <div class="NewProductContainer HSCodesMenuPopUp AddNewHSCodeContainer animated fadeInDown" *ngIf="AddNewHSCode == true;" style="z-index: 202;width: 20%;">
      <div class="NewProductContainerTitleBar">
        <p>{{'AddNewHSCode' | translate}}</p>
        <i class="material-icons" (click)="AddNewHSCode = false;">close</i>
      </div>
      <div class="NewProductContainerBody">
        <mat-form-field appearance="outline" class="HSCodePropertyTextBox">
          <mat-label>{{ 'Code' | translate }}</mat-label>
          <input matInput placeholder="{{ 'Code' | translate }}" autocomplete="off" [(ngModel)]="this.NewHSCode.Code">
        </mat-form-field>

        <mat-form-field appearance="outline" class="HSCodePropertyTextBox">
          <mat-label>{{ 'ImportTax' | translate }}</mat-label>
          <input matInput placeholder="{{ 'ImportTax' | translate }}" autocomplete="off" [(ngModel)]="this.NewHSCode.ImportTax">
        </mat-form-field>

        <mat-form-field appearance="outline" class="HSCodePropertyTextBox">
          <mat-label>{{ 'ExportTax' | translate }}</mat-label>
          <input matInput placeholder="{{ 'ExportTax' | translate }}" autocomplete="off" [(ngModel)]="this.NewHSCode.ExportTax">
        </mat-form-field>
     
        <mat-form-field appearance="outline"class="HSCodePropertyTextBox">
          <mat-label>{{ 'COO' | translate }}</mat-label>
          <mat-select name="COO" [compareWith]="this.parent.compareFn" [(ngModel)]="this.NewHSCode.COO">
            <mat-option *ngFor="let c of this.Countries" [value]="c">
              {{c.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline"class="HSCodePropertyTextBox">
          <mat-label>{{ 'ImportingCountry' | translate }}</mat-label>
          <mat-select name="COO" [compareWith]="this.parent.compareFn" [(ngModel)]="this.NewHSCode.ImportingCountry">
            <mat-option *ngFor="let c of this.Countries" [value]="c">
              {{c.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
      <div class="NewProductContainerCommands">
        <button mat-raised-button color="primary" class="AddNewProductButton" style="width: 92%;" (click)="AddUpdateHSCode(this.NewHSCode);">
          {{'AddNewHSCode' | translate}}
        </button>
      </div>
    </div>

    <div class="NewProductContainer HSCodesMenuPopUp animated fadeInDown" *ngIf="ShowHSCodesMenu == true;">
      <div class="NewProductContainerTitleBar">
        <p>{{'HSCodesMenu' | translate}}</p>
        <i class="material-icons">security</i>
      </div>
      <div class="NewProductContainerBody">

      <div class="HSCodesSearchContainer">
        <input type="text" class="HSCodesSearchTextBox" [(ngModel)]="this.HSCodesFilter.Code" (ngModelChange)="this.HSCodesSearchText.next($event)">
        <mat-spinner *ngIf="loadingHSCodes" class="HSCodesSearchLoader" [diameter]="25"></mat-spinner>

        <div class="HSCodesSearchTextBoxResults" *ngIf="this.ShowGetHSCodeViesData == true;">
          <div class="AddNewHSCodeFromSearchResultsButton" (click)="this.InitializeNewHSCode(this.HSCodesFilter.Code);">
            <span>{{'AddNew' | translate}}</span>
          </div>
        </div>
      </div>
      
      <div class="HSCodesList" *ngIf="this.HSCodes?.length > 0">
        <div class="HSCodesElement HSCodesElementTitle">
          <div class="HSCodesElementCell" style="width: 25%;">
            <span>{{'HSCode' | translate}}</span>
          </div>
          <div class="HSCodesElementCell">
            <span>{{'ImportTax' | translate}}</span>
          </div>
          <div class="HSCodesElementCell">
            <span>{{'ExportTax' | translate}}</span>
          </div>
          <div class="HSCodesElementCell">
            <span>{{'COO' | translate}}</span>
          </div>
          <div class="HSCodesElementCell">
            <span>{{'ImportingCountry' | translate}}</span>
          </div>
          <div class="HSCodesElementCell">
            
          </div>
        </div>
        <div class="HSCodesElement" *ngFor="let hs of this.HSCodes" [value]="hs">
          <div class="HSCodesElementCell" style="width: 25%;padding-top: 10px;">
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'HSCode' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'HSCode' | translate }}*" autocomplete="off" [(ngModel)]="hs.Code">
            </mat-form-field>
          </div>
          <div class="HSCodesElementCell" style="padding-top: 10px;">
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'ImportTax' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'ImportTax' | translate }}*" autocomplete="off" [(ngModel)]="hs.ImportTax">
            </mat-form-field>
          </div>
          <div class="HSCodesElementCell" style="padding-top: 10px;">
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'ExportTax' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'ExportTax' | translate }}*" autocomplete="off" [(ngModel)]="hs.ExportTax">
            </mat-form-field>
          </div>
          <div class="HSCodesElementCell" style="padding-top: 10px;">
            <mat-form-field appearance="outline"class="HSCodePropertyTextBox">
              <mat-label>{{ 'COO' | translate }}</mat-label>
              <mat-select name="COO" [compareWith]="this.parent.compareFn" [(ngModel)]="hs.COO">
                <mat-option *ngFor="let c of this.Countries" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="HSCodesElementCell" style="padding-top: 10px;">
            <mat-form-field appearance="outline"class="HSCodePropertyTextBox">
              <mat-label>{{ 'ImportingCountry' | translate }}</mat-label>
              <mat-select name="COO" [compareWith]="this.parent.compareFn" [(ngModel)]="hs.ImportingCountry">
                <mat-option *ngFor="let c of this.Countries" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="HSCodesElementCell" style="padding-top: 10px;">
            <i class="material-icons" (click)="AddUpdateHSCode(hs);">edit</i>
            <i class="material-icons" (click)="DeleteHSCode(hs.ID);">close</i>
          </div>

          <div class="HSCodeDescriptionBar" (click)="hs.ShowDescriptions = !hs.ShowDescriptions; InitializeHSCodeDescription(hs); GetHSCodeDescriptions(hs);">...</div>
          <div class="HSCodeDescriptions" *ngIf="hs.ShowDescriptions == true;">
            <div class="HSCodeDescriptionRow">
              <div class="HSCodeDescriptionRowCell" style="width: 100%;">
                <div class="HSCodesElementCell" style="width: 70%;padding-top: 10px;">
                  <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                    <mat-label>{{ 'Description' | translate }}*</mat-label>
                    <input matInput placeholder="{{ 'Description' | translate }}*" autocomplete="off" [(ngModel)]="this.HSCodeDescription.Description">
                  </mat-form-field>
                </div>
                <div class="HSCodesElementCell" style="width: 10%;padding-top: 10px;">
                  <mat-form-field appearance="outline"class="HSCodePropertyTextBox">
                    <mat-label>{{ 'Language' | translate }}</mat-label>
                    <mat-select name="Language" [compareWith]="this.parent.compareFn" [(ngModel)]="this.HSCodeDescription.Language">
                      <mat-option *ngFor="let l of this.Languages" [value]="l">
                        {{l.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="HSCodesElementCell" style="width: 20%;padding-top: 10px;">
                    <div class="HSCodeDescriptionAdd" (click)="AddUpdateHSCodeDescription(this.HSCodeDescription);">+</div>
                </div>
              </div>
            </div>
            <div class="HSCodeDescriptionRow" *ngFor="let d of hs.Descriptions" [value]="d">
              <div class="HSCodesElementCell" style="width: 70%;padding-top: 10px;">
                <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                  <mat-label>{{ 'Description' | translate }}*</mat-label>
                  <input matInput placeholder="{{ 'Description' | translate }}*" autocomplete="off" [(ngModel)]="d.Description">
                </mat-form-field>
              </div>
              <div class="HSCodesElementCell" style="width: 10%;padding-top: 10px;">
                <mat-form-field appearance="outline"class="HSCodePropertyTextBox">
                  <mat-label>{{ 'Language' | translate }}</mat-label>
                  <mat-select name="Language" [compareWith]="this.parent.compareFn" [(ngModel)]="d.Language">
                    <mat-option *ngFor="let l of this.Languages" [value]="l">
                      {{l.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="HSCodesElementCell" style="width: 20%;padding-top: 10px;">
                <div class="HSCodeDescriptionAdd" (click)="AddUpdateHSCodeDescription(d);">+</div>
                <div class="HSCodeDescriptionAdd" style="background: #fd4f57;" (click)="DeleteHSCodeDescription(d);">x</div>
            </div>
            </div>
          </div>
        </div>
      </div>

      </div>
      <div class="NewProductContainerCommands">
        <button mat-raised-button color="primary" class="AddNewProductButton" (click)="ShowHideHSCodesMenu();">
          <i class="material-icons">edit</i>
          {{'OK' | translate}}
        </button>

        <button mat-raised-button color="primary" style="float: right;margin-right: 2%; background: #32aa3a;" class="AddNewProductButton" (click)="this.InitializeNewHSCode(this.HSCodesFilter.Code);">
          {{'AddNew' | translate}}
        </button>
      </div>
    </div>

    <div class="PageContentTitle">
        <div class="PageContentTitleIntro">
            <i class="material-icons">sd_storage</i>
            <i class="material-icons">storage</i>
            <p class="PageContentTitleParagraph">{{'Products' | translate}}</p>
        </div>

          <mat-form-field class="ButtonFilterDropDown" appearance="outline">
            <mat-label>{{'SelectBrand' | translate}}*</mat-label>
            <input class="BrandSelect"
                   type="text"
                   placeholder="{{'SelectBrand' | translate}}"
                   matInput
                   [matAutocomplete]="auto2"
                   [(ngModel)]="this.FilterBrandName"
                   (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                   (click)="InitializeBrands();">
            <i style="height: 25px; line-height:25px;" class="material-icons BrandSelectCloseIcon">keyboard_arrow_down</i>
            <mat-autocomplete #auto2="matAutocomplete">
              <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Filter.Brand = brand;this.FilterBrandName = brand.Name;AddActiveFilter(brand.Name, 'Brand');">
                {{brand.Name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          

          <div class="TitleSearchInputContainer">
            <mat-spinner *ngIf="loadingProducts" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
            <input type="text" class="TitleSearchInput" placeholder="{{'SearchProducts' | translate}}" autocomplete="off" (click)="InitializeSearchProduct();" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
            <i class="material-icons TitleSearchInputContainerSearchIcon" *ngIf="loadingProducts != true;">search</i>
            <i class="material-icons TitleSearchInputContainerCloseIcon" *ngIf="this.SearchedProducts?.length > 0;" (click)="this.SearchTerm = ''; this.SearchedProducts.length = 0; this.Filter.SearchTerm = '';">close</i>
          
            <div class="TitleSearchInputResultsContainer" *ngIf="this.SearchedProducts?.length > 0">
              <div class="TitleSearchInputResult" *ngFor="let p of this.SearchedProducts" (click)="GetIndustryProductByID(p.ProductID, true);">
                <div class="TitleSearchInputResultTitle">
                  {{p.FKBrandName}} {{p.ProductName}}
                </div>
                <div class="TitleSearchInputResultDate">
                  {{p.ProductPartNumber}}
                </div>
              </div>
            </div>
          </div>

          <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="InitializeNewIndustryProduct();" style="float:right;margin-right: 10px;">
            {{'AddNewProduct' | translate}}
            <i class="material-icons">add</i>
          </button>
    </div>

      <div class="PageContentBody animated fadeIn">
        <div class="PageContentBodyTopCommands">
          <!-- <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="OpenResetIndustryProductsSearchResultsQuestion();" style="float:right;margin-right: 10px;">
            {{'ResetSearchResults' | translate}}
            <i class="material-icons">add</i>
          </button>
          <div class="CleaningCount" style="float: left;">
            {{'OfferErrorsToBeCleaned' | translate}}: <span *ngIf="CleaningCount != null;">{{CleaningCount}}</span>
          </div>
          <button (click)="CleanIndustryProductsDataOffers();" *ngIf="CleaningCount != null;" mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" style="float: left;margin-right: 10px;background: #0082e6;">
            {{'CleanOffers' | translate}}
            <i class="material-icons">find_replace</i>
          </button>

          <button (click)="CleanIndustryProductsDupplicateValues();" *ngIf="CleaningCount != null;" mat-raised-button color="warn" class="TitleFilterButton NewTaskButton" style="float: left;margin-right: 10px;background: #f60;">
            {{'CleanDupplicates' | translate}}
            <i class="material-icons">data_usage</i>
          </button> -->

          <button (click)="ShowHideHSCodesMenu();" mat-raised-button class="TitleFilterButton NewTaskButton" style="float: right;margin-right: 10px;background: #020044; color: #fff;">
            {{'HSCodesMenu' | translate}}
            <i class="material-icons">security</i>
          </button>

          <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="ShowResetIndustryProductsSearchResultsQuestion = true;" style="float:right;margin-right: 10px;">
            {{'ResetSearchResults' | translate}}
            <i class="material-icons">add</i>
          </button>
        </div>

        <div class="PageContentBodyElementsContainer">
          <div class="TaskRow TaskHeadderRow">
            <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
              #
            </div>
            <div class="ProductsCol" style="width: 25%;">
              {{'Product' | translate}}
            </div>
            <div class="ProductsCol" style="width: 20%;">
              {{'Properties' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'Brand' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'EventRegister' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'UpdateingUser' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'ActiveProduct' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;text-align:center;">
              {{'Actions' | translate}}
            </div>
          </div>

          <div class="ProductsContainer">
            <div class="ProductRow" *ngFor="let p of this.Products; let i=index;">
              <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                {{i + 1}}
              </div>
              <div class="ProductsCol" style="width: 25%;padding-top: 20px;">
                <p class="ProductsColMain">
                  <span class="ProductsColMainSpan" style="color: #0082e6;">{{'Name' | translate}}: </span>
                  {{p.Name}}
                </p>
                <p class="ProductsColMain">
                  <span class="ProductsColMainSpan" style="color: #0082e6;">{{'Manufacturer' | translate}}: </span>
                  {{p.Brand?.Name}}
                </p>
                <p class="ProductsColMain" *ngIf="p.PartNumber != null;">
                  <span class="ProductsColMainSpan">{{'PartNumber' | translate}}: </span>
                  {{p.PartNumber}}
                </p>

                <p class="OfferShowButton unSelectable" *ngIf="p.ShowOffers != true && p.ListPriceOffers?.length > 0;" (click)="p.ShowOffers = !p.ShowOffers;">
                  <span>{{'Offers' | translate}}</span>
                  <i class="material-icons">keyboard_arrow_down</i>
                </p>
                <p class="OfferShowButton unSelectable" *ngIf="p.ShowOffers == true && p.ListPriceOffers?.length > 0;" (click)="p.ShowOffers = !p.ShowOffers;">
                  <span>{{'Offers' | translate}}</span>
                  <i class="material-icons">keyboard_arrow_up</i>
                </p>
              </div>
              <div class="ProductsCol" style="width: 20%;padding-top: 18px;">
                <p class="ProductsColMain" *ngIf="p.Stats?.HSCode != null;">
                  <span class="ProductsColMainSpan">{{'HSCode' | translate}}: </span>
                  {{p.Stats?.HSCode}}
                </p>
                <p class="ProductsColMain" *ngIf="p.Stats?.COO != null;">
                  <span class="ProductsColMainSpan">{{'COO' | translate}}: </span>
                  {{p.Stats?.COO?.Name}}
                </p>
                <p class="ProductsColMain" *ngIf="p.Stats?.EAN != null;">
                  <span class="ProductsColMainSpan">{{'EAN' | translate}}: </span>
                  {{p.Stats?.EAN}}
                </p>
                <p class="ProductsColMain" *ngIf="p.Stats?.Weight != null;">
                  <span class="ProductsColMainSpan">{{'Weight' | translate}}: </span>
                  {{p.Stats?.Weight}} {{p.Stats?.WeightMeasurementType?.Name}}
                </p>
                <p class="ProductsColMain">
                  <span class="ProductsColMainSpan">{{'ProductManufacturingStatus' | translate}}: </span>
                  {{p.ManufacturingStatus?.Name}}
                </p>
                <p class="ProductsColMain">
                  <span class="ProductsColMainSpan">{{'ProductVersionStatus' | translate}}: </span>
                  {{p.VersionStatus?.Name}}
                </p>
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{p.Brand?.Name}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{p.EventRegisterUI}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{p.Updater?.UIName}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                <span *ngIf="p.Activated">{{'Activ' | translate}}</span>
              </div>
              <div class="ProductsCol" style="width: 10%;text-align: center;padding-top: 10px;">
                <i class="material-icons actionsArrow unSelectable" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
                <mat-menu #menu="matMenu">
                 <button mat-menu-item class="ReceptionMenuButton" (click)="InitializeNewIndustryProduct(p);">
                     <i class="material-icons">edit</i>
                     <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
                 </button>

                 <button mat-menu-item class="ReceptionMenuButton" (click)="InitializeNewIndustryProduct(p, true);">
                  <i class="material-icons">content_copy</i>
                  <span>{{ 'CopyProduct' | translate }}</span>
                 </button>

                 <button mat-menu-item class="ReceptionMenuButton" (click)="this.NewProduct = p; this.ShowDeleteProductQuestion = true;">
                   <i class="material-icons">close</i>
                   <span>{{ 'Delete' | translate }}</span>
                 </button>
                </mat-menu>
              </div>

              <div class="OffersTableContainer animated fadeIn" *ngIf="p.ShowOffers == true;">
               <div class="OffersTableHeadder">
                <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                  #
                </div>
                <div class="ProductsCol" style="width: 25%;">
                  {{'PriceInformation' | translate}}
                </div>
                <div class="ProductsCol" style="width: 20%;">
                  {{'Supplier' | translate}}
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  {{'Currency' | translate}}
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  {{'LeadTime' | translate}}
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  {{'IsStockOffer' | translate}}
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  {{'StockQuantity' | translate}}
                </div>
                <div class="ProductsCol" style="width: 10%;text-align:center;">
                  
                </div>
               </div>

              <div class="OffersRow" *ngFor="let o of p.ListPriceOffers; let j=index;" [ngClass]="{'stockOption': o.IsStockOffer == true, 'manufacturerOption': o.IsStockOffer != true}">
                <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                  {{j + 1}}
                </div>
                <div class="ProductsCol" style="width: 25%;">
                  <p class="ProductsColMain" style="width: 25%;padding-top: 20px;">
                    <span class="ProductsColMainSpan" style="color: #0082e6;">{{'PurchasePrice' | translate}}: </span>
                    <span *ngIf="o.DiscountedPrice > 0;">{{o.DiscountedPrice}} {{o.Currency?.Name}}</span>
                    <span *ngIf="!(o.DiscountedPrice > 0);">------</span>
                  </p>
                </div>
                <div class="ProductsCol" style="width: 20%;">
                  {{o.Partner?.Name}}
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  {{o.Currency?.Name}}
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  {{o.LeadTime?.Units}} {{o.LeadTime?.Type?.Name}}
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  <span *ngIf="o.IsStockOffer == true;">{{'Yes'| translate}}</span>
                  <span *ngIf="o.IsStockOffer == false;">{{'No'| translate}}</span>
                </div>
                <div class="ProductsCol" style="width: 10%;">
                  {{o.StockQuantity}}
                </div>
                <div class="ProductsCol" style="width: 10%;text-align:center;">
                  
                </div>
               </div>
              </div>
            </div>
          </div>

        </div>
      </div>
  </div>